<template>
<div id="register-confirm-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered mt-n3">
        <div class="modal-content">
            <div class="modal-body p-4">
                <div class="text-center">
                    <i class="ri-information-line h1 text-info"></i>
                    <h4 class="mt-3 mb-3">
                        고시원 정보 등록 / 수정 안내사항
                    </h4>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            신규 등록 및 정보 수정 요청은 영업일 기준 1~3일 소요됩니다.
                        </li>
                        <li class="list-group-item">
                            수정 요청을 여러 번 하실 경우, 가장 최근에 요청한 내용이 기준이 되어 등록됩니다.
                        </li>
                        <li class="list-group-item">
                            요청 결과 및 내역은 사이트 내, 알림과 메시지로 발송됩니다.
                        </li>
                        <li class="list-group-item">
                            고시원 대표 사진은 방 전체가 보이는 사진을 사용해주세요. 잘못된 사진이나 화질이 낮은 사진은 거절될 수 있습니다.
                        </li>
                        <li class="list-group-item">
                            욕설이나 선정적인 문구, 사진이 포함된 경우 거절될 수 있습니다.
                        </li>
                        <li class="list-group-item">
                            제공하는 모든 정보는 사실에 기반해야 합니다. 허위 정보가 포함된 경우 요청이 거절될 수 있습니다.
                        </li>
                    </ul>
                </div>
            </div>
            <div class="modal-footer" style="justify-content: center; border-top: none;">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                    닫기
                </button>
                <button type="button" class="btn btn-primary my-2" @click="$emit('save-kosiwon')">
                    {{ btnText }}
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ["btnText"]
}
</script>
